import React from 'react';
import { DeckGLLayer } from '@leverege/ui-google-maps-elements';
import { BitmapLayer } from '@deck.gl/layers';
import { TileLayer } from '@deck.gl/geo-layers';
import { GlobalState, UI } from '@leverege/ui-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_ARRAY = Object.freeze([]);
export default function SourceLayerRenderer(opts) {
  const {
    layer,
    selected,
    baseId,
    opacity,
    index
  } = opts;
  const srcId = baseId;
  const layerId = `${srcId}-layer`;
  const lid = `${layerId}-${index}`;
  const {
    source
  } = layer;
  if (source == null) {
    return EMPTY_ARRAY;
  }
  const {
    minzoom: minZoom,
    maxzoom: maxZoom,
    tileSize,
    tiles,
    bounds
  } = source;
  if (!selected || !tiles || Array.isArray(tiles) && tiles.length === 0) {
    return null;
  }
  const mapEditing = UI.get(GlobalState.get(), 'mapEditing');
  const op = mapEditing ? 0.1 : opacity;
  return /*#__PURE__*/_jsx(DeckGLLayer, {
    id: lid,
    layer: new TileLayer({
      id: lid,
      data: tiles,
      minZoom,
      maxZoom,
      tileSize,
      opacity: op,
      extent: bounds,
      renderSubLayers: props => {
        const {
          bbox: {
            west,
            south,
            east,
            north
          }
        } = props.tile;
        if (west == null || south == null || east == null || north == null) {
          return null;
        }
        return new BitmapLayer(props, {
          data: null,
          image: props.data,
          bounds: [west, south, east, north]
        });
      }
    })
  }, lid);

  // const sourceKey = source.type === 'geojson' ? 'geoJsonSource' : 'tileJsonSource'
  // const rtn = [ React.createElement( Source, { key : sid, id : sid, [sourceKey] : source } ) ]

  // if ( source.type === 'raster' ) {
  //   const paint = selected ? { ...noFade, 'raster-opacity' : opacity } : PAINT_INVISIBLE
  //   const layout = selected ? LAYOUT_VISIBLE : LAYOUT_INVISIBLE
  //   rtn.push( (
  //     <Layer key={lid} 
  //       id={lid} 
  //       type="raster"
  //       sourceId={sid}
  //       before={before}
  //       paint={paint}
  //       layout={layout} /> ) )

  // } else if ( Array.isArray( layers ) ) {
  //   layers.forEach( ( layer, idx ) => { 
  //     const id = `${lid}-${idx}`
  //     const { paint : p, layout : l, ...rest } = layer
  //     rtn.push( <Layer {...rest} 
  //       key={id} 
  //       id={id} 
  //       sourceId={sid}
  //       before={before}
  //       paint={p}
  //       layout={selected ? l || LAYOUT_VISIBLE : LAYOUT_INVISIBLE} /> )
  //   } )
  // }
  // return rtn
}